import { showError, showSuccess } from "./message-toggler";
import messages from "../messages";

const lang = document.documentElement.lang.startsWith("fr") ? "fr" : "en";

const isRequired = (value) => (value === "" ? false : true);
const checkField = (field) => {
  let valid = false;
  const name = field.value.trim();

  if (!isRequired(name)) {
    showError(field, messages[lang].required);
  } else {
    showSuccess(field);
    valid = true;
  }
  return valid;
};

export { checkField, isRequired };
